var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardPanel',{attrs:{"title":"工单处理趋势","meta":"单位：单"}},[_c('div',{staticClass:"work-legend"},[_c('span',[_c('i',{staticClass:"blue"}),_vm._v("新增工单")]),_c('span',[_c('i',{staticClass:"green"}),_vm._v("完成工单")]),_c('span',[_c('i',{staticClass:"line"}),_vm._v("平均处理时长（小时）")])]),_c('div',{ref:"chart",staticClass:"work-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }